import Protein from 'molbio/proteins/Protein';
import {PolymerTabState} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

export default class AlphaFoldTabState extends PolymerTabState<Protein> {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: '3D Structure',
      closeable: false,
      preferenceKey: 'protein-structure',
    };
  }
}
